import {Component, HostBinding, Input} from '@angular/core';
import {ButtonComponent} from '../core/button.component';

@Component({
  selector: 'spb-primary-flex-button',
  templateUrl: './primary-flex-button.component.html',
})
export class PrimaryFlexButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-primary-flex-button') hostBaseClass = true;
  @Input() flat = false;
}
